/**
 * An ISO timestamp as a long, locale-natural date ("26 June 2026").
 *
 * One spelling for the whole app. The contact drawer alone carried three
 * near-copies of this — two spelled the day `numeric`, one `2-digit` — so the
 * same date read differently depending on which panel you were looking at.
 * `numeric` wins: it is what every locale does with a day on its own.
 *
 * Empty or unparseable input returns '' rather than "Invalid Date": callers
 * drop the line instead of printing a value nobody can read.
 *
 * `timeZone` pins the calendar the day is read in. Left out, it is the reader's
 * own; a date another channel already announced in a fixed zone (an email
 * dating a deadline in UTC) passes that zone so both name the same day.
 */
export function formatLongDate(
  iso: string | null | undefined,
  locale: string,
  options: { timeZone?: string } = {}
): string {
  if (!iso) return '';

  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';

  return date.toLocaleDateString(locale, {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    timeZone: options.timeZone,
  });
}
